import { render, staticRenderFns } from "./MailDetail.vue?vue&type=template&id=16e3e43a&scoped=true&"
import script from "./MailDetail.vue?vue&type=script&lang=js&"
export * from "./MailDetail.vue?vue&type=script&lang=js&"
import style0 from "./MailDetail.vue?vue&type=style&index=0&id=16e3e43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e3e43a",
  null
  
)

export default component.exports